/*if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
*/

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        console.log('ProductForm component initialized');

        this.form = this.querySelector('form');
        console.log('Form element:', this.form);

        this.variantIdInput = this.form.querySelector('[name=id]');
        console.log('Variant ID input:', this.variantIdInput);

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        console.log('Submit event listener added');

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        console.log('Cart element:', this.cart);

        this.submitButton = this.querySelector('[type="submit"]');
        console.log('Submit button:', this.submitButton);

        this.submitButtonText = this.submitButton.querySelector('span');
        console.log('Submit button text:', this.submitButtonText);

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
          console.log('Submit button aria-haspopup attribute set');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        console.log('Hide errors:', this.hideErrors);

        this.headwrapMessage = document.getElementById('headwrap-message');
        console.log('Headwrap message element:', this.headwrapMessage);

        // Add event listener for variant selection changes
        this.addVariantChangeListener();

        // Add event listener for style radio button changes
        this.addStyleChangeListener();
      }

      addVariantChangeListener() {
        // Get all variant selects
        const variantSelects = this.querySelectorAll('.product-form__input--dropdown select');
        console.log('Variant selects:', variantSelects);

        variantSelects.forEach(select => {
          select.addEventListener('change', () => {
            console.log('Variant select changed');
            this.logSelectedVariant();
            this.updateVariantText(); // Update the variant text when selection changes
            this.checkHeadwrapSelection();
          });
        });
      }

      addStyleChangeListener() {
        const styleRadios = this.querySelectorAll('input[name^="Style-"]');
        console.log('Style radio buttons:', styleRadios);

        styleRadios.forEach(radio => {
          radio.addEventListener('change', () => {
            console.log('Style radio button changed');
            this.logSelectedVariant();
            this.updateVariantText(); // Update the variant text when style changes
            this.checkHeadwrapSelection();
          });
        });
      }

      updateVariantText() {
        const variantSelects = this.querySelectorAll('.product-form__input--dropdown select');
        variantSelects.forEach(select => {
          const selectedOption = select.options[select.selectedIndex];
          const variantTextElement = document.getElementById('variant-text'); // Ensure you have an element to display this
          if (variantTextElement) {
            variantTextElement.textContent = selectedOption.textContent; // Display the variant text
            console.log('Variant text updated:', selectedOption.textContent);
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('Form submitted');

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          console.log('Submit button is disabled');
          return;
        }

        this.handleErrorMessage();
        this.checkHeadwrapSelection();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        console.log('Submit button loading state set');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('Fetch response:', response);

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('Fetch error:', e);
          })
          .finally(() => {
            console.log('Fetch request completed');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        console.log('Handling error message:', errorMessage);
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      checkHeadwrapSelection() {
        // Check if the selected radio button value is 'Headwrap'
        const selectedRadio = this.querySelector('input[name^="Style-"]:checked');
        if (selectedRadio) {
          console.log('Selected Style:', selectedRadio.value);
          if (selectedRadio.value === 'Headwrap') {
            if (this.headwrapMessage) {
              this.headwrapMessage.removeAttribute('hidden');
              console.log('Headwrap message displayed');
            }
          } else {
            if (this.headwrapMessage) {
              this.headwrapMessage.setAttribute('hidden', 'hidden');
              console.log('Headwrap message hidden');
            }
          }
        } else {
          console.log('No style selected');
        }
      }

      logSelectedVariant() {
        // Log selected variant from dropdowns and radio buttons
        const variantSelects = this.querySelectorAll('.product-form__input--dropdown select');
        variantSelects.forEach(select => {
          console.log('Dropdown selected value:', select.options[select.selectedIndex].textContent);
        });

        const selectedRadios = this.querySelectorAll('input[name^="Style-"]:checked');
        selectedRadios.forEach(radio => {
          console.log('Selected radio value:', radio.value);
        });
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}



